import Vue from "vue";
import App from "@/App.vue";
import "@/registerServiceWorker";
import store from "@/store";
import VueApexCharts from "vue-apexcharts";

//plugins
import router from "@/plugins/router";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
import errorService from "@/plugins/errors";
import "@/plugins/apexcharts";
import "@/plugins/axios";
import { titleMixin } from "@/plugins/pageTitle";
import "@/styles/icons.css";
import "@/styles/style.scss";
import "@/styles/variables_to_css.scss";

//filters
import "@/filters/index";
import "@/static/logos";
import "reflect-metadata";

if (process.env.NODE_ENV != "development") {
  Vue.config.productionTip = false;
  Vue.config.devtools = false;
}

Vue.mixin(titleMixin);

errorService.useWindowErrorHandler();
errorService.useUnhandledRejection();

Vue.config.errorHandler = (error, vm, trace) => {
  errorService.onVueError(error, vm, trace);
};

Vue.config.warnHandler = (msg, vm, trace) => {
  errorService.onVueWarning(msg, vm, trace);
};

Vue.use(VueApexCharts);
Vue.component("ApexCharts", VueApexCharts);

const vue = new Vue({
  i18n,
  router,
  store: store.original,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

export default vue;
